export default __webpack_public_path__ + "static/media/ctg-3a.ce1a1b3a.webp";